import { useLocation } from 'react-router';

export default function useHeaderVisibility() {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();

  const showDepartmentSelect = [
    '/excessshortage',
    '/salebill',
    '/salebillb2b',
    '/stockcheck',
    '/requesttostore',
    '/receivefromdepartment',
    '/departmenttransfer',
    '/productioninclusive'
  ].includes(path);

  const showProjectSelect = ['/board', '/project', '/timelineview', '/timesheet', '/team', '/listview'].includes(path);

  const showCounterNo = [
    '/salebill',
    '/salebillb2b',
    '/servicebill',
    '/cashbook',
    '/simplecashbook',
    '/kitchenorderticket',
    '/purchase',
    '/stockreceipt',
    '/departmenttransfer',
    '/excessshortage',
    '/stocktransfer'
  ].includes(path);

  return {
    showDepartmentSelect,
    showProjectSelect,
    showCounterNo
  };
}
